import { ThemeProvider } from './theme/ThemeProvider'
import { AuthProvider } from './auth/AuthProvider'
import { AppStateProvider } from './state/store'
import { LoadingProvider } from './components/feedback/LoadingProvider'
import { ErrorBoundary } from './components/feedback/ErrorBoundary'
import { AppRouter } from './app/router'

/**
 * APP-004 — Shell con autenticación.
 * Proveedores: tema → auth (sesión JWT) → estado global → carga. El enrutador decide
 * qué vistas son públicas (/login) o protegidas. Solo frontend: habla HTTP/JSON.
 */
export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppStateProvider>
          <LoadingProvider>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </LoadingProvider>
        </AppStateProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}
